import { render, staticRenderFns } from "./SaveFiliation.vue?vue&type=template&id=1745c1b0&scoped=true"
import script from "./SaveFiliation.vue?vue&type=script&lang=js"
export * from "./SaveFiliation.vue?vue&type=script&lang=js"
import style0 from "./SaveFiliation.vue?vue&type=style&index=0&id=1745c1b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745c1b0",
  null
  
)

export default component.exports